module.exports = __webpack_public_path__ + "static/media/heavyrain-flood-icon.30d57587.svg";